import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/students", label: "生徒一覧" }
];

export function AdminEnrollmentsPage() {
  return (
    <PageScaffold
      title="Admin Enrollments"
      description="所属一覧画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに enrollment 一覧を表示します。</p>
    </PageScaffold>
  );
}
